var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"491bacc29e867df1aaab452c428f6e401ed0e074"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-js"]={id:"491bacc29e867df1aaab452c428f6e401ed0e074"};
      